/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMonatsauswertungLayoutDto } from '../../models/create-monatsauswertung-layout-dto';
import { MonatsauswertungLayoutDto } from '../../models/monatsauswertung-layout-dto';

export interface UpdateMonatsauswertungLayout$Json$Params {
  id: string;
      body?: CreateMonatsauswertungLayoutDto
}

export function updateMonatsauswertungLayout$Json(http: HttpClient, rootUrl: string, params: UpdateMonatsauswertungLayout$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MonatsauswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, updateMonatsauswertungLayout$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonatsauswertungLayoutDto>;
    })
  );
}

updateMonatsauswertungLayout$Json.PATH = '/v1/monatsauswertungen/layouts/{id}';
